import React from "react";
import './pr-card.scss';


export default class PrCardComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            togleHeight: false
        }
        this.component = React.createRef();
    }

    componentDidMount(){
        const item = this.component.current.querySelector('ul');
        item.style.setProperty('--element-height', `${item.getBoundingClientRect().height}px`);
    }

    render(){
        return (
            <div className={`card ${this.props.type} ${this.props.state}`} ref={this.component}>
                <p className="title extra-title--h2">{this.props.data.name}</p>
                <ul>
                    {this.props.data.list.map((value, index) => 
                        <li className="extra-title--h6" key={index}>{value}</li>
                    )}
                </ul>
            </div>
        );
    }
}